module.exports = __webpack_public_path__ + "img/Logo_ESILV_fd_couleur.35c8a14f.png";